import { useMutation, useQueryClient } from "@tanstack/react-query"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"
import type { UesConfig } from "../../domain/entities/ues-config"
import { makeUpdateKbUesConfig } from "../../domain/use-cases/update-kb-ues-config"

const updateKbUesConfig = makeUpdateKbUesConfig(httpKnowledgeBaseRepository)

export const useUpdateKbUesConfig = (kbId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (config: UesConfig) => updateKbUesConfig(kbId, config),
    onSuccess: () =>
      void queryClient.invalidateQueries({
        queryKey: ["kbUesConfig", kbId],
      }),
  })
}
